module.exports = __webpack_public_path__ + "static/img/cstSer_bg_white_10.2cc21f11.svg";